import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { DESKTOP_IMAGE_SRC } from '~app/modules/generic/constants/menu-navigation-banner.constants';
import { ThematicResources } from '~app/modules/storyblok/models/storyblok-global-content.model';
import { ApplicationEventService } from '~shared/modules/application-event/services';
import { PromoImageLinkClickApplicationEvent } from '~shared/modules/application-event/models/promo-image-link-click-event.model';

@Component({
  selector: 'app-menu-navigation-banner',
  templateUrl: './menu-navigation-banner.component.html',
  styleUrls: ['./menu-navigation-banner.component.scss'],
})
export class MenuNavigationBannerComponent {
  @Input() isMobile: boolean;
  @Input() thematicResources: ThematicResources;
  @Output() navigateTo = new EventEmitter<string>();
  @Output() menuClosed = new EventEmitter<null>();

  constructor(private applicationEventService: ApplicationEventService, private router: Router) {}

  onLinkClick(): void {
    this.menuClosed.emit();
  }

  getImageSrc(src: string): string {
    return DESKTOP_IMAGE_SRC.replace('{src}', src);
  }

  firePromoImageLinkClickEvent(link: string): void {
    this.applicationEventService.publish(new PromoImageLinkClickApplicationEvent(link, this.router.url));
  }

  onNavigate(link: string) {
    this.navigateTo.emit(link);
    this.firePromoImageLinkClickEvent(link);
  }
}
